import React, { useEffect } from 'react';

import { Button, Typography } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';

import { company_fields } from '../constants/create_company_fields';
import CustomInput from '../../../../components/CustomInput';
import service from '../service';
import { toast } from 'react-toastify';
import { useBoundStore } from '../../../../stores';
import { useNavigate } from 'react-router-dom';

function CreateCompanyDrawer() {

  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);
  const [valid, setValid] = React.useState(false);
  const navigate = useNavigate()

  const [companyFormData, setCompanyFormData] = React.useState({
    companyName: '',
    address: '',
    description: '',
  });

  const validateForm = () => {
    if (
      companyFormData.companyName
      // companyFormData.barcodeNumber &&
      // companyFormData.status
    ) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleSave = async () => {
    // console.log(companyFormData);
    await service.saveCompany(companyFormData).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Şirket başarıyla oluşturuldu.');
      } else {
        toast.error('Şirket oluşturulurken hata oluştu.');
      }
      navigate('/definitions/companies');
      toggleRightDrawer();
    });
  };

  useEffect(() => {
    validateForm();
  }, [companyFormData]);

  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Şirket Ekle</Typography>
      </div>
      <div>
        <>
          <div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {company_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={companyFormData[field.key]}
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {
                        setCompanyFormData({
                          ...companyFormData,
                          [field.key]: value,
                        });
                      }}
                    />
                  </div>
                );
              })}
              <Button
                disabled={!valid}
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Save />}
                onClick={() => handleSave()}
                className="mx-2"
              >
                Kaydet
              </Button>
            </div>
          </div>
        </>

      </div>
    </div>
  );
}

export default CreateCompanyDrawer;
